module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Basic-Graphics-Frame",
    attrs: {
      "id": "_idContainer000"
    }
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "alt": "",
      "src": "image/curl_alt_gray.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer001"
    }
  }, [_c('p', {
    staticClass: "Basic-Paragraph ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer002"
    }
  }, [_c('h1', {
    staticClass: "TitlePg1"
  }, [_vm._v("Forager’s "), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Pantry")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Basic-Graphics-Frame",
    attrs: {
      "id": "_idContainer003"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/divider_alt_gray.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer004"
    }
  }, [_c('h2', {
    staticClass: "TitlePg2"
  }, [_vm._v("Cooking"), _c('span', {
    staticClass: "CharOverride-3"
  }), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("with")]), _c('span', {
    staticClass: "CharOverride-3"
  }), _vm._v("Wild Edibles")])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer005"
    }
  }, [_c('h3', {
    staticClass: "TitlePg3"
  }, [_vm._v("Ellen Zachos ")]), _vm._v(" "), _c('p', {
    staticClass: "TitlePg4"
  }, [_vm._v("Photographs by Douglas Merriam")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Basic-Graphics-Frame",
    attrs: {
      "id": "_idContainer006"
    }
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "alt": "Photo of the recipe above.",
      "src": "image/logo.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer007"
    }
  }, [_c('p', {
    staticClass: "CIP"
  }, [_vm._v("Digital Edition 1.0")]), _vm._v(" "), _c('p', {
    staticClass: "CIP"
  }, [_vm._v("Text © 2021 Ellen Zachos")]), _vm._v(" "), _c('p', {
    staticClass: "CIP"
  }, [_vm._v("Photographs © 2021 Douglas Merriam")]), _vm._v(" "), _c('p', {
    staticClass: "CIP"
  }, [_vm._v("All rights reserved. No part of this book may be reproduced by any means whatsoever without written permission from the publisher, except brief portions quoted for purpose of review.")]), _vm._v(" "), _c('p', {
    staticClass: "CIP"
  }, [_vm._v("Published by")]), _vm._v(" "), _c('p', {
    staticClass: "CIP"
  }, [_vm._v("Gibbs Smith")]), _vm._v(" "), _c('p', {
    staticClass: "CIP"
  }, [_vm._v("P.O. Box 667")]), _vm._v(" "), _c('p', {
    staticClass: "CIP"
  }, [_vm._v("Layton, Utah 84041")]), _vm._v(" "), _c('p', {
    staticClass: "CIP"
  }, [_vm._v("1.800.835.4993 orders")]), _vm._v(" "), _c('p', {
    staticClass: "CIP"
  }, [_vm._v("www.gibbs-smith.com")]), _vm._v(" "), _c('p', {
    staticClass: "CIP"
  }, [_vm._v("Cover by Kimberly Glyder")]), _vm._v(" "), _c('p', {
    staticClass: "CIP"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data")]), _vm._v(" "), _c('p', {
    staticClass: "CIP"
  }, [_vm._v("Names: Zachos, Ellen, author. | Merriam, Douglas, photographer (expression) ")]), _vm._v(" "), _c('p', {
    staticClass: "CIP"
  }, [_vm._v("Title: The forager’s pantry : cooking with wild edibles / Ellen Zachos ; photographs by Douglas Merriam.  ")]), _vm._v(" "), _c('p', {
    staticClass: "CIP"
  }, [_vm._v("Description: First edition. | Layton, Utah : Gibbs Smith, [2021] | Includes  index. ")]), _vm._v(" "), _c('p', {
    staticClass: "CIP"
  }, [_vm._v("Identifiers: LCCN 2020033186 | ISBN 9781423656746 (hardcover) | ISBN 9781423656753 (epub)  ")]), _vm._v(" "), _c('p', {
    staticClass: "CIP"
  }, [_vm._v("Subjects: LCSH: Cooking (Wild foods) | LCGFT: Cookbooks. ")]), _vm._v(" "), _c('p', {
    staticClass: "CIP"
  }, [_vm._v("Classification: LCC TX823 .Z33 2021 | DDC 641.6—dc23 ")]), _vm._v(" "), _c('p', {
    staticClass: "CIP"
  }, [_vm._v("LC record available at "), _c('a', {
    attrs: {
      "href": "https://lccn.loc.gov/2020033186",
      "target": "_blank"
    }
  }, [_vm._v("https://lccn.loc.gov/2020033186")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer008"
    }
  }, [_c('p', {
    staticClass: "DED"
  }, [_vm._v("I dedicate this book to my mother, Anne Delight Colby Zachos, who died before she could see it in print. Although she was not a forager herself, she loved good food and had a reputation as an excellent cook. She was always eager to try any wild edible I put in front of her. ")])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer009"
    }
  }, [_c('h3', {
    staticClass: "Sidebar-Head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor000"
    }
  }), _vm._v("Special thanks")]), _vm._v(" "), _c('p', {
    staticClass: "Normal-no-indent"
  }, [_vm._v("Writing a book during a pandemic has been interesting. It’s easy to write and cook when you’re socially distanced, but how do you forage for key ingredients that don’t grow where you live? Fortunately, foragers are a supportive bunch, and I’m grateful to the many friends who generously sent me ingredients I had intended to gather for myself. Thank you Mark Hardy, Mike Dechter, Kristen Davenport, Erica Marciniac Davis, and Julie Gracie for helping to make this book p"), _c('span', {
    staticClass: "no-break"
  }, [_vm._v("ossible.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("I am also grateful to Douglas Merriam who was not only wonderful to work with, but made my food look as good as it tastes. And thanks to Sadie Lowry, a thoughtful, intelligent, and thorough "), _c('span', {
    staticClass: "no-break"
  }, [_vm._v("editor. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("And as always, thank you to my three favorite proofreaders, Elizabeth Zachos, John Keane, and Michael Mac"), _c('span', {
    staticClass: "no-break"
  }, [_vm._v("Donald. ")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5316151d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Foragers_Pantry_Digital.vue
// module id = 57
// module chunks = 0